import { render } from "./UserAnalysis.vue?vue&type=template&id=0a4644a7&scoped=true"
import script from "./UserAnalysis.vue?vue&type=script&lang=js"
export * from "./UserAnalysis.vue?vue&type=script&lang=js"

import "./UserAnalysis.vue?vue&type=style&index=0&id=0a4644a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4644a7"]])

export default __exports__